(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[702],{

/***/ 2286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/fotografia-documental/documental-familia",
      function () {
        return __webpack_require__(4590);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Loading() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 4470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PortfolioShow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./components/loading.js
var loading = __webpack_require__(138);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(3587);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 17 modules
var dialog = __webpack_require__(1);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(8494);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(7814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(1436);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
;// CONCATENATED MODULE: ./components/modal.js











function Modal(param) {
    var isOpenObj = param.isOpenObj, setIsOpen = param.setIsOpen, data = param.data, photoAlt = param.photoAlt;
    var cancelButtonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: isOpenObj.isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: function() {
                return setIsOpen({
                    isOpen: false,
                    picNum: 0
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center min-h-screen p-4 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-block bg-midnight rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-midnight p-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        onClick: function() {
                                            return setIsOpen({
                                                isOpen: false,
                                                picNum: 0
                                            });
                                        },
                                        className: "absolute right-4 top-4 text-slate-700 bg-white rounded-full w-[20px] !h-[20px] cursor-pointer z-10",
                                        icon: free_solid_svg_icons_index_es/* faTimes */.NBC
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        initialSlide: isOpenObj.picNum,
                                        pagination: true,
                                        navigation: true,
                                        modules: [
                                            swiper_esm/* Pagination */.tl,
                                            swiper_esm/* Navigation */.W_
                                        ],
                                        className: "w-full h-[90vh]",
                                        ref: cancelButtonRef,
                                        children: data && data.map(function(fotoPath, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative w-full h-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: fotoPath,
                                                        alt: photoAlt,
                                                        layout: "fill",
                                                        objectFit: "contain",
                                                        quality: 100,
                                                        priority: true
                                                    })
                                                })
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(9637);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/related.js




function Related(param) {
    var title = param.title;
    var ref = (0,react.useState)([]), entriesToRender = ref[0], setEntriesToRender = ref[1];
    (0,react.useEffect)(function() {
        setEntriesToRender(sampleSize(entriesArr.filter(isDiferentFromRender), 3));
    }, []);
    var isDiferentFromRender = function(entryTitle) {
        return entryTitle !== title;
    };
    var sampleSize = function(param) {
        var _param = (0,_to_array/* default */.Z)(param), arr = _param.slice(0), n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var currentIndex = arr.length, randomIndex;
        while(currentIndex != 0){
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            var ref;
            ref = [
                arr[randomIndex],
                arr[currentIndex]
            ], arr[currentIndex] = ref[0], arr[randomIndex] = ref[1], ref;
        }
        return arr.slice(0, n);
    };
    var entriesArr = [
        {
            title: "Florescer",
            subTitle: "Fotografia Autoral",
            link: "/portfolio/fotografia-autoral/florescer"
        },
        {
            title: "Isolamento",
            subTitle: "Fotografia Autoral",
            link: "/portfolio/fotografia-autoral/isolamento"
        },
        {
            title: "Media",
            subTitle: "Fotografia Autoral",
            link: "/portfolio/fotografia-autoral/media"
        },
        {
            title: "Perman\xeancia",
            subTitle: "Fotografia Autoral",
            link: "/portfolio/fotografia-autoral/permanencia"
        },
        {
            title: "Retratos",
            subTitle: false,
            link: "/portfolio/retratos"
        },
        {
            title: "Fotografia Corporativa",
            subTitle: false,
            link: "/portfolio/fotografia-corporativa"
        },
        {
            title: "Documental de Fam\xedlia",
            subTitle: "Fotografia Documental",
            link: "/portfolio/fotografia-documental/documental-familia"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4 lg:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "uppercase font-josefin-sans text-white text-4xl mb-8 lg:mb-20",
                children: "N\xe3o deixar de ver"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t border-l border-almost-white/50 grid grid-cols-1 lg:grid-cols-3",
                children: entriesToRender.map(function(entry, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-r border-b border-almost-white/50 flex flex-col justify-center items-center p-14",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-almost-white font-lato uppercase text-sm mb-4",
                                children: entry.subTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: entry.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-white text-center font-josefin-sans text-4xl",
                                    children: entry.title
                                })
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/portfolioShow.js







function PortfolioShow(param) {
    var title = param.title, subTitle = param.subTitle, children = param.children, folderPath = param.folderPath, mainPhotoUrl = param.mainPhotoUrl, photoAlt = param.photoAlt;
    var ref = (0,react.useState)({
        isOpen: false,
        picNum: 0
    }), isOpen = ref[0], setIsOpen = ref[1];
    var fetcher = function(url) {
        return fetch(url).then(function(res) {
            return res.json();
        });
    };
    var data = (0,dist/* default */.ZP)("/api/readfiles?path=".concat(folderPath), fetcher).data;
    var Gallery = function() {
        if (!data) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "p-2 text-almost-white font-lato uppercase text-sm",
                        children: "A carregar as fotos"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 gap-6 lg:grid-cols-2",
            children: data.map(function(fotoPath, idx) {
                return(//<div key={idx} className="relative h-[50vh] shadow-lg shadow-black">
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: fotoPath,
                    alt: photoAlt,
                    width: 760,
                    height: 625,
                    objectFit: "cover",
                    quality: 100,
                    className: "cursor-pointer shadow-lg shadow-black",
                    onClick: function() {
                        return setIsOpen({
                            isOpen: true,
                            picNum: idx
                        });
                    }
                }, idx));
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2 items-center mb-28 lg:mb-[200px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mb-5 h-[50vh] shadow-lg shadow-black",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mainPhotoUrl,
                            alt: photoAlt,
                            layout: "fill",
                            objectFit: "cover",
                            quality: 100,
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 lg:px-0 lg:pl-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-josefin-sans text-white text-4xl",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-lato text-almost-white text-lg",
                                children: subTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto text-white px-4 lg:px-0 font-lato mb-28 lg:mb-[200px]",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto mb-28",
                children: Gallery()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto mb-8 lg:mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Related, {
                    title: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                isOpenObj: isOpen,
                setIsOpen: function(isModalOpen) {
                    return setIsOpen(isModalOpen);
                },
                photoAlt: photoAlt,
                data: data
            })
        ]
    });
};


/***/ }),

/***/ 4590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DocumentalFamilia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_sections_portfolioShow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4470);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function DocumentalFamilia() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Sara Fontoura - Fotografia Documental de Fam\xedlia"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Sara Fontoura - Fotografia Documental de Fam\xedlia"
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Fotografia Documental de Fam\xedlia"
                    }, "ogdesc")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_sections_portfolioShow__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Documental de Fam\xedlia",
                subTitle: "Fotografia Documental",
                folderPath: "fotos/documental/documental_familia",
                mainPhotoUrl: "/fotos/documental/documental_familia/DSC09373.webp",
                photoAlt: "Documental de Familia - Fotografia Documental",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-2",
                        children: "Eventos e acontecimentos do cotidiano podem-se tornar verdadeiras obras de arte quando fotografadas no momento certo."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-2",
                        children: "Procuro com a fotografia documental registar de forma art\xedstica acontecimentos do cotidiano, para que os possa viver recordando-os sempre que quiser."
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,185,206,774,888,179], function() { return __webpack_exec__(2286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);